import tu from "@/utils/toolutil";

/**
 *宋建国：2020/3/20 10:30
 *描述：混入对象意义：
 * 1、每个实例组件随机定义一个唯一标识，
 * 2、在组件销毁时处理Matt消息分发取消操作
 *版本：1.0
 */
export const CaseOnly = {
  data() {
    return {
      _XYJ_CaseOnly_Id: tu.createRandom(),
      _XYJ_CallBack_Function: null
    };
  },
  mounted() {
    // if ( this.$route.params._XYJ_CallBack_Function){
    //    this._XYJ_CallBack_Function = this.$route.params._XYJ_CallBack_Function;
    // } else if (this.$route.query._XYJ_CallBack_Function) {
    //   if ( this.$route.params._XYJ_CallBack_Function){
    //      this._XYJ_CallBack_Function = this.$route.params._XYJ_CallBack_Function;
    //   }
    // }
  },
  beforeDestroy() {
    this.$mqtt.clearSubScribe(this.$data._XYJ_CaseOnly_Id);
    // if(this.$tu.isFunction(this._XYJ_CallBack_Function)){
    //   this._XYJ_CallBack_Function();
    // }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/CaseOnlyMixin.js